import {IBankDetailFormModel, IData} from "../types/bank-detail.types";
import {BankDetail} from "../../../../../domains/models/employee";
import server from "../../../../../server";


export function viewMapper(data: IData): IBankDetailFormModel {
    const {bank} = data;
    return {
        name: bank.name,
        accountHolderName: bank.accountHolderName,
        accountNumber: bank.accountNumber,
        branchName: bank.branchName,
        branchCode: bank.branchCode,
        ifscCode: bank.ifscCode
    };
}

export function modelMapper(data: IBankDetailFormModel): BankDetail {
    return {
        name: data.name,
        accountHolderName: data.accountHolderName,
        accountNumber: data.accountNumber,
        branchName: data.branchName,
        branchCode: data.branchCode,
        ifscCode: data.ifscCode
    };
}

export async function fetchData(employeeId: string) {
    const bank: BankDetail = await server.employee.bank.get(employeeId);

    return {bank};
}
